import { Box, DashboardModuleListItem } from '@domain-group/suit-theme'

import usePortalOptionValue from '@hooks/usePortalOptionValue'

import { confirmDelete } from '@functions/entity'

import type { PortalOptionValueModel } from '@models/types'

interface PortalOptionValueActionsProps {
  portalOptionValue: PortalOptionValueModel,
}

const PortalOptionValueActions = (props: PortalOptionValueActionsProps) => {
  const { portalOptionValue } = props

  const {
    callbacks: {
      createOrEditPortalOptionValue,
      deletePortalOptionValue: deleteFn,
    },
  } = usePortalOptionValue(portalOptionValue)

  return (
    <Box justifyContent="center">
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Icon
        marginRight="medium"
        onClick={() => createOrEditPortalOptionValue()}
        type="edit"
      />

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Icon
        onClick={() => confirmDelete({ callbacks: { deleteFn }, strings: { entityName: 'Option Value' } })}
        type="delete"
      />
    </Box>
  )
}

export default PortalOptionValueActions
